
import { Component, EventEmitter, Inject, OnInit, Output, TemplateRef, ViewChild, DOCUMENT } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { AuthService } from 'src/app/services/auth.service';
import { EventService } from 'src/app/services/event.service';
import { LanguageService } from 'src/app/services/language.service';
import { CreateNewClientComponent } from 'src/app/shared/components/create-new-client/create-new-client.component';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit {
	@ViewChild('changePasswordModal') changePasswordModal!: TemplateRef<any>;
	@ViewChild('closeAccountModal') closeAccountModal!: TemplateRef<any>;
	@ViewChild('successModal') successModal!: TemplateRef<any>;
	@ViewChild('createNewClient') createNewClient!: CreateNewClientComponent;
	
	element: any;
  mode: string | undefined;
  @Output() mobileMenuButtonClicked = new EventEmitter();

  total = 0;
  cart_length: any = 0;
  userData: any;
  clientData: any;
  userRole: any;

  flagvalue: any;
  valueset: any;
  countryName: any;
  cookieValue: any;

	listLang: any[] = [];

	changePasswordModalRef!: any;
	passresetForm!: UntypedFormGroup;
	currentField = false;
	passwordField = false;
	confirmField = false;
	passNotTheSame = false;

	submitted = false;
	spinner = false;
	success = false;
	message = '';

  constructor(@Inject(DOCUMENT) private document: any, private eventService: EventService, public languageService: LanguageService,
    public _cookiesService: CookieService, public translate: TranslateService, private authService: AuthService,
    private router: Router, private formBuilder: UntypedFormBuilder, private modalService: NgbModal) { }

  ngOnInit(): void {
		this.userData = this.authService.currentUserValue;
		this.userRole = this.authService.role;

    this.element = document.documentElement;
		this.listLang = this.languageService.listLang();

    // Cookies wise Language set
    this.cookieValue = this._cookiesService.get('lang');
    const val = this.listLang.filter(x => x.lang === this.cookieValue);
    this.countryName = val.map(element => element.text);
    if (val.length === 0) {
      if (this.flagvalue === undefined) { this.valueset = 'assets/images/flags/us.svg'; }
    } else {
      this.flagvalue = val.map(element => element.flag);
    }
  }

  toggleMobileMenu(event: any) {
    document.querySelector('.hamburger-icon')?.classList.toggle('open')
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }

  fullscreen() {
    document.body.classList.toggle('fullscreen-enable');
    if (
      !document.fullscreenElement && !this.element.mozFullScreenElement &&
      !this.element.webkitFullscreenElement) {
      if (this.element.requestFullscreen) {
        this.element.requestFullscreen();
      } else if (this.element.mozRequestFullScreen) {
        /* Firefox */
        this.element.mozRequestFullScreen();
      } else if (this.element.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.element.webkitRequestFullscreen();
      } else if (this.element.msRequestFullscreen) {
        /* IE/Edge */
        this.element.msRequestFullscreen();
      }
    } else {
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        /* Firefox */
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        /* IE/Edge */
        this.document.msExitFullscreen();
      }
    }
  }

  changeMode(mode: string) {
    this.mode = mode;
    this.eventService.broadcast('changeMode', mode);

    switch (mode) {
      case 'light':
        document.documentElement.setAttribute('data-bs-theme', "light");
        document.documentElement.setAttribute('data-sidebar', "light");
        break;
      case 'dark':
        document.documentElement.setAttribute('data-bs-theme', "dark");
        document.documentElement.setAttribute('data-sidebar', "dark");
        break;
      default:
        document.documentElement.setAttribute('data-bs-theme', "dark");
        break;
    }
  }

  setLanguage(text: string, lang: string, flag: string) {
    this.countryName = text;
    this.flagvalue = flag;
    this.cookieValue = lang;
    this.languageService.setLanguage(lang);
  }

  logout() {
    this.authService.logout();
  }

	changeCompany() {
		this.authService.emptyClientSubject();
	}

	openChangePasswordModal() {
		this.currentField = false;
		this.passwordField = false;
		this.confirmField = false;

		this.passresetForm = this.formBuilder.group({
			current_password: ['', [Validators.required]],
      password: ['', [Validators.required, Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]).{8,}$/)]],
			cpassword: ['', [Validators.required]]
		});

		
		this.changePasswordModalRef = this.modalService.open(this.changePasswordModal, { size: 'l', backdrop: 'static', keyboard : false });
	}

	changePassword() {
		this.submitted = true;

		if (this.passresetForm.invalid) {
			return;
		}

		if (this.f['password'].value !== this.f['cpassword'].value) {
			this.passNotTheSame = true;
			return;
		}
		
		this.passresetForm.value.change_password = true;
		this.spinner = true;

		this.authService.changeUserPassword(this.passresetForm.value).subscribe({
			next: (res) => {
				this.submitted = false;
				this.spinner = false;
				this.success = true;
				this.message = res.message;

				this.changePasswordModalRef.close();
				this.modalService.open(this.successModal, { size: 'l', backdrop: 'static', keyboard : false });
			},
			error: (err) => {
				this.spinner = false;this.submitted = false;
				this.spinner = false;
				this.success = false;
				this.message = err.message ? err.message : err;
				
				this.changePasswordModalRef.close();
				this.modalService.open(this.successModal, { size: 'l', backdrop: 'static', keyboard : false });
			}
		});
	}

	openCloseAccountModal() {
		this.modalService.open(this.closeAccountModal, { size: 'l', backdrop: 'static', keyboard : false });
	}

	openTipsModal(event: any, content: any) {
		event.preventDefault();
		this.modalService.open(content, { size: 'l', backdrop: 'static', keyboard : false });
	}

	closeAccount() {
		this.submitted = true;
		this.spinner = true;
	}

	closeModal() {
		this.modalService.dismissAll();
	}

	get f() { return this.passresetForm.controls; }

	togglepasswordField() {
		this.passwordField = !this.passwordField;
	}

	toggleconfirmField() {
		this.confirmField = !this.confirmField;
	}

	togglecurrentField() {
		this.currentField = !this.currentField;
	}

	openCreateNewClient() {
		this.createNewClient.openModal();
	}

	closeSubmittion(event: boolean) {
		if (event) {
			this.authService.getloggedInUserDetails().subscribe({
				next: (user: any) => {
					this.authService.setCurrentUserSubject(user);
					this.authService.emptyClientSubject();
					this.router.navigate(['/']);
				},
				error: () => {
					this.authService.toastErrorMessage('Somthing went wrong!', 'Fetching Error');
				}
			});
		}
	}
}
